import {fetchCities} from "../../../api/locations";
import {isNumber} from "lodash/lang";


const LOCATION_KEY = 'SELECTED_CITY'
const storage = {
    setItem: (city) => {
        city?.id && (localStorage.setItem(LOCATION_KEY, JSON.stringify(city)))
    },
    getItem: () => {
        const city = localStorage.getItem(LOCATION_KEY)
        const parsedCity = JSON.parse(city)

        return parsedCity?.id ? parsedCity : null
    }
}

const locations = {
    namespaced: true,

    state: {
        cities: [],
        otherCity: 'Москва',
        selectedCity: storage.getItem(),
        citiesPhones: {
            "Самара": "8462265110",
            "Тольятти": "8888888888"
        },
    },

    getters: {
        getCities(state) {
            return state.cities
        },
        getOrderCity(state) {
            return state.selectedCity.id === 0 ?
                state.otherCity :
                state.selectedCity.title
        },
        getSelectedCity: (state)=> state.selectedCity,
        getSelectedCityPhone: (state) => state.citiesPhones[state.selectedCity.title] || '8462265110',
        isOtherCitySelected: (state) =>state.selectedCity.id === 1
    },

    mutations: {
        citiesIndex(state, cities) {
            Array.isArray(cities) && (state.cities = cities)
        },
        setSelectedCity(state, city) {
            city?.id && (state.selectedCity = city)
            city?.id && (storage.setItem(city))
        },
        setOtherCity(state, val) {
            state.otherCity = val
        }
    },

    actions: {
        async citiesIndex({state, commit}) {
            const cities = await fetchCities()
            commit('citiesIndex', cities)

            if(!state.selectedCity?.id) commit('setSelectedCity', cities[0])
        }
    },

};


export default locations;
